import { Mapper } from 'src/base/mapper'
import { PostCodeTypeEntity } from 'src/data/entities/common.entity'
import { PostCodeTypeModel } from 'src/domain/models/common.model'

export class PostCodeMapper extends Mapper<PostCodeTypeEntity, PostCodeTypeModel> {
	mapFrom(param: PostCodeTypeEntity): PostCodeTypeModel {
		return this.resultData(param)
	}

	mapTo(param: PostCodeTypeModel): PostCodeTypeEntity {
		return this.resultData(param)
	}

	resultData(param: PostCodeTypeEntity | PostCodeTypeModel) {
		return {
			postCode: param.postCode,
			subDistrictCode: param.subDistrictCode,
		}
	}
}
